import { Deck, DeckCard } from "@apiserver-rest/ponder-data-client-base";
import { DeckGroup } from "@ponder-features/user/decks/deck/group/deck-group";
import { environment } from "../../../../../environments/environment";

export class MagicDeckGroupOther extends DeckGroup {
    public constructor() {
        super("Other", `${environment.ponderImageBaseUrl}/magic/set/mb2.svg`);
    }
    
    public override isValid(deck: Deck, card: DeckCard): boolean {
        return true;
    }
}